const reservedUsernames = require('reserved-usernames');

const removals = new Set([
  'community',
  'button',
  'about',
  'email'
]);

const reservedNames = new Set(reservedUsernames);

removals.forEach((removal) => reservedNames.delete(removal));

function isReserved(name) {
  return reservedNames.has(name.toLowerCase());
}

module.exports = {
  removals,
  reservedNames,
  isReserved,
};
